export const formatLicenseNumber = (number) => {
  return number ? number : "N/A";
};
